import { graphql, useStaticQuery } from "gatsby"
import { TFooter } from "../types"

const footer = (): TFooter => {
  const query = useStaticQuery(
    graphql`
      query {
        allFooter {
          nodes {
            title
            backgroundColor {
              red
              blue
              green
              alpha
            }
            backgroundImage {
              id
              title
              ... on DatoCmsAsset {
                gatsbyImageData(
                  imgixParams: {crop: "focalpoint", fit: "crop", w: "1600", h: "900"}
                )
              }
            }
            phonePlaceholderText
            phoneSubmitText
            emailPlaceholderText
            emailSubmitText
            socialNetworks {
              ... on SocialNetwork {
                network
                link
              }
            }
          }
        }
      }
    `
  )
  return query.allFooter.nodes[0]
}

export default footer
